export default {
  name: 'project_invite',
  component_path: 'modules/procedures/blocks/accept_invite/BlockAcceptProjectInviteToken',
  static_mandatory: ['required']
}